import { EasmScanConfigurationAssetGridBaseDataProvider } from '../dataProvider/EasmScanConfigurationAssetGridBaseDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ, API_TYPE_NIRVANA } from '../../../../webcomponents.constants';

export class EasmScanConfigurationAssetGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, EasmScanConfigurationAssetGridBaseDataProvider);
    this.map.set(API_TYPE_NIRVANA, EasmScanConfigurationAssetGridBaseDataProvider);
  }
}
